import { getExtent } from '../utils/scale';
import { useMovingWindow } from './useMovingWindow';
import { useStrip } from './useStrip';

export const useStripWindow = () => {
  const { xScale } = useStrip();
  const duration = getExtent(xScale.domain());
  return useMovingWindow(duration);
};
